<template>
  <section class="content white flex-grow">
    <table-oppgaver :limit="50" :large="true" :brukerId="brukerId" :statusId="statusId" />
  </section>
</template>

<script>
import TableOppgaver from './TableOppgaver'

export default {
  name: 'PageOppgaver',
  components: {
    TableOppgaver
  },
  props: {
    brukerId: {
      required: true
    },
    statusId: {
      required: false,
      default () {
        return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/PageOppgaver.vue